const LogoColor = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_LOGO_COLOR}`
const LogoBlack = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_LOGO_BLACK}`
const LogoWhite = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_LOGO_WHITE}`

export {
    LogoColor,
    LogoBlack,
    LogoWhite
}